import { memo, useCallback } from "react";

import type { DiscountTargetType, DiscountTermType } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";
import { SelectField } from "@/components/ui/form/fields/select-field";

import * as Constants from "../constants";

type Props = {
	// ディスカウント金額（固定金額）
	staticAmount: ForNodeType<number>;
	// ディスカウント方法の変数（顧客属性）
	staticTargetType: DiscountTargetType;
	// ディスカウント方法の変数（期間）
	staticTermType: DiscountTermType;

	// ディスカウント金額の変更（固定金額）
	onChangeDiscountWithStatic: (amount: number) => void;
	// ディスカウント方法の変数の変更（顧客属性）
	onChangeStaticTargetType: (value: DiscountTargetType) => void;
	// ディスカウント方法の変数の変更（期間）
	onChangeStaticTermType: (value: DiscountTermType) => void;
};

export const OrdinaryWithStatic = memo(
	({
		staticAmount,
		staticTargetType,
		staticTermType,
		//
		onChangeDiscountWithStatic,
		onChangeStaticTargetType,
		onChangeStaticTermType,
	}: Props) => {
		/**
		 * ディスカウント金額の変更（固定金額）
		 */
		const handleChangeDiscountWithStatic = useCallback(
			(amount?: number) => {
				onChangeDiscountWithStatic(amount!); // 未入力（undefined）の入力を一時的に許容する。許容することでzodによるバリデーションエラーを出している。
			},
			[onChangeDiscountWithStatic],
		);
		/**
		 * ディスカウント方法の変数の変更（顧客属性）
		 */
		const handleChangeStaticTargetType = useCallback(
			(value: string) => {
				onChangeStaticTargetType(value as DiscountTargetType);
			},
			[onChangeStaticTargetType],
		);
		/**
		 * ディスカウント方法の変数の変更（期間）
		 */
		const handleChangeStaticTermType = useCallback(
			(value: string) => {
				onChangeStaticTermType(value as DiscountTermType);
			},
			[onChangeStaticTermType],
		);

		return (
			<div>
				<p>通常料金から</p>

				<div className="flex flex-wrap items-center gap-3">
					<div className="flex items-center gap-x-3">
						<SelectField
							value={staticTargetType}
							options={Constants.StaticTargetTypeOptions}
							handleValueChange={handleChangeStaticTargetType}
						/>

						<p>ごとに</p>

						<SelectField
							value={staticTermType}
							options={Constants.StaticTermTypeOptions}
							handleValueChange={handleChangeStaticTermType}
						/>
					</div>

					<div className="flex items-center gap-x-3">
						<InputNumberField
							handleInput={handleChangeDiscountWithStatic}
							value={staticAmount.value}
							errorMessage={staticAmount.error}
						/>

						<p>円（税込）引き</p>
					</div>
				</div>
			</div>
		);
	},
);
